import { DateTime } from "luxon";
import { DataModel } from "../../base/index.js";
import type {
  ExtensionInstanceContractData,
  ExtensionInstanceContractStatus,
} from "./types.js";

export class ExtensionInstanceContract extends DataModel<ExtensionInstanceContractData> {
  public readonly interactionDeadline?: DateTime;
  public readonly terminationTargetDate?: DateTime;
  public readonly status?: ExtensionInstanceContractStatus;

  public constructor(data: ExtensionInstanceContractData) {
    super(data);
    this.interactionDeadline = data.interactionDeadline
      ? DateTime.fromISO(data.interactionDeadline)
      : undefined;
    this.terminationTargetDate = data.terminationTargetDate
      ? DateTime.fromISO(data.terminationTargetDate)
      : undefined;
    this.status = data.status;
  }
}
